import { render, staticRenderFns } from "./Pesan.vue?vue&type=template&id=6ea017bc&"
import script from "./Pesan.vue?vue&type=script&lang=js&"
export * from "./Pesan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports